import React, { useState, useEffect } from 'react';
import ScreenHeader from '../ScreenHeader/ScreenHeader';
import DisplayScreen, { DisplayState } from '../DisplayScreen/DisplayScreen';
import { useCarSortationDemo } from '../../hooks/useCarSortationDemo';
import { CarData } from '../CarInfo/CarInfo';
import './CarSortationDemo.css';

interface CarSortationDemoProps {
  title?: string;
  className?: string;
}

const CarSortationDemo: React.FC<CarSortationDemoProps> = ({
  title,
  className = '',
}) => {
  const defaultTitle = `Tracker Leak Detection`;

  const [currentState, setCurrentState] = useState<DisplayState>('READY');
  const [currentCarData, setCurrentCarData] = useState<CarData | null>(null);

  const { currentCar } = useCarSortationDemo();

  useEffect(() => {
    if (currentCar) {
      processCar(currentCar);
    }
  }, [currentCar]);

  const processCar = (carData: CarData) => {
    const incomingState: DisplayState =
      carData.designation === 'READY'
        ? 'READY'
        : carData.designation === 'Lora OBD detected'
        ? 'Lora OBD detected'
        : 'READY';

    // Update immediately on each event
    setCurrentState(incomingState);
    setCurrentCarData(carData);
  };

  return (
    <div
      className={`car-sortation-demo ${className}`}
      data-testid="car-sortation-container"
    >
      <ScreenHeader title={title || defaultTitle} />
      <DisplayScreen state={currentState} carData={currentCarData} />
    </div>
  );
};

export default CarSortationDemo;
